import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Flex,
  Text,
  Image,
  VStack,
  HStack,
  Spacer,
  Divider,
} from '@chakra-ui/react';
import { converteLevel } from 'utils/dynConverter';

const PromptAssignCard = ({ promptData }) => {
  const { essayTitle, level, essayType, url, essayPrompt, minWordCount } =
    promptData;

  return (
    <Box width={'100%'}>
      <Box
        p={3}
        borderWidth="1px"
        borderRadius="lg"
        boxShadow="md"
        bg="green.50"
      >
        <VStack align="start" spacing={2}>
          {essayTitle && (
            <Box>
              <Text fontWeight="bold" color="gray.600">
                Title:
              </Text>
              <Text>{essayTitle}</Text>
            </Box>
          )}

          <HStack w="100%">
            <Box>
              <Text fontWeight="bold" color="gray.600">
                Level:
              </Text>
              <Text>{converteLevel(level)}</Text>
            </Box>
            <Spacer />
            <Box>
              <Text fontWeight="bold" color="gray.600">
                Essay Type:
              </Text>
              <Text>{essayType}</Text>
            </Box>
            <Spacer />
            {minWordCount && (
              <>
                <Box>
                  <Text fontWeight="bold" color="gray.600">
                    Min Word Count:
                  </Text>
                  <Text>{minWordCount}</Text>
                </Box>
              </>
            )}
          </HStack>
          <Divider />
          <Box>
            <Text fontWeight="bold" color="gray.600">
              Prompt / Instruction:
            </Text>
            <Text textAlign="justify" color="gray.700">
              {essayPrompt}
            </Text>
          </Box>
          {url && (
            <Flex justifyContent="center" mt={1}>
              <Image
                src={url}
                alt="Essay Image"
                borderRadius="md"
                maxH="200px"
                objectFit="cover"
              />
            </Flex>
          )}
        </VStack>
      </Box>
    </Box>
  );
};

PromptAssignCard.propTypes = {
  promptData: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ),
};

export default PromptAssignCard;
